import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import ProfileImg from '../assets/images/Lakshay.png'

const LakshayChoudhary = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Lakshay Choudhary | Property Consultant - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={ProfileImg}
                    Title="Lakshay Choudhary"
                    Designation="Property Consultant"
                    ORN="44515"
                    PhoneNumberLink="+971507088917"
                    PhoneNumber="+971 50 708 8917"
                    WhatsappLink="971507088917"
                    Whatsapp="+971 50 708 8917"
                    Email="Lakshay@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={ProfileImg}
                    Title="Lakshay Choudhary"
                    Designation="Property Consultant"
                    ORN="44515"
                    PhoneNumberLink="+971507088917"
                    PhoneNumber="+971 50 708 8917"
                    WhatsappLink="971507088917"
                    Whatsapp="+971 50 708 8917"
                    Email="Lakshay@800homes.ae"
                />
            </section>
        </>
    )
}

export default LakshayChoudhary
